export default "__VITE_ASSET__BwP1QEHU__"